// third-party
import { createSlice } from '@reduxjs/toolkit';
import { returnFiltersQueryString } from 'helpers/objectFunctions';

// project imports
import { ARYABHATTA_API_DOMAIN_V1 } from 'config';
import { devConsolelog } from 'helpers/utilityFunctions';
import { dispatch } from 'store';
import { DEFAULT_ERROR_MESSAGE } from 'store/constant';
import axios from 'utils/axios';
import { openSnackbar } from './snackbar';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    data: {
        utilities: {
            filters: []
        }
    },
    filters: {},
    autoSuggestData: {
        dropdownData: []
    },
    filterOptions: {}
};

const slice = createSlice({
    name: 'memberList',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        // setData
        setData(state, action) {
            const { count = 0, next = null, previous = null, results = {}, page = 0 } = action.payload;
            const { utilities = {}, member_list: memberList = [] } = results || {};

            state.data.count = count;
            state.data.next = next;
            state.data.previous = previous;
            state.data.utilities = utilities;
            state.data.memberList = memberList;
            state.data.currentPage = page;
        },

        setFilters(state, action) {
            state.filters = action.payload;
        },

        setIsLoading(state, action) {
            const { loadingField = '', isLoading = false } = action.payload || {};
            state[loadingField] = isLoading;
        },

        setAutosuggestData(state, action) {
            const {
                code__completion: memCodeData = [],
                company_name__completion: companyNameData = [],
                email__completion: emailData = [],
                name__completion: nameData = [],
                freeText = ''
            } = action.payload;

            let autosuggestData = [memCodeData[0]?.options, nameData[0]?.options, companyNameData[0]?.options, emailData[0]?.options].find(
                (arr) => arr.length
            );

            if (!autosuggestData) autosuggestData = [];

            // autosuggestData.unshift({ _source: { code: freeText } });

            const autosuggestDropdownData = autosuggestData.map((data) => {
                const { _source: source = {} } = data || {};
                const { organization = {} } = source || {};
                const { wallet = {} } = organization || {};
                const { currency = '' } = wallet || {};
                const { name = '', code = '', email = '', company_name: companyName = '', id = null } = source || {};

                return { code, name, email, companyName, label: `${code} ${name} ${email} ${companyName}`, id, currency };
            });

            devConsolelog('ujb34', autosuggestDropdownData);

            state.autoSuggestData.dropdownData = autosuggestDropdownData;
        },

        setCurrentPage(state, action) {
            state.data.currentPage = action.payload;
        },

        setMemberDropdownData(state, action) {
            state.filterOptions.acmData = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getMemberListDataAndFilters(pageChangeUrl = '', filterType = '', newPage = 0) {
    dispatch(slice.actions.setIsLoading({ loadingField: 'isDataLoading', isLoading: true }));
    return async () => {
        let url = `${ARYABHATTA_API_DOMAIN_V1}acm/members?`;

        if (pageChangeUrl) {
            url = pageChangeUrl;
        }
        if (filterType) {
            const filterQueryString = returnFiltersQueryString(filterType);

            url = `${url}${filterQueryString}`;
        }
        try {
            const response = await axios.get(url, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });

            dispatch(slice.actions.setData({ ...response.data, page: filterType ? 0 : newPage }));
            dispatch(slice.actions.setIsLoading({ loadingField: 'isDataLoading', isLoading: false }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.setIsLoading({ loadingField: 'isDataLoading', isLoading: false }));
        }
    };
}

export function getAutosuggestData(searchedVal = '', withoutFreeText = false) {
    return async () => {
        // let url = `${ARYABHATTA_API_DOMAIN}api/v1/acm/members?ordering=-created_at`;
        const url = `${ARYABHATTA_API_DOMAIN_V1}acm/member/suggest?code__completion=${searchedVal}&company_name__completion=${searchedVal}&name__completion=${searchedVal}&email__completion=${searchedVal}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });
            devConsolelog('response getAutoSuggestData', response.data, searchedVal);
            if (withoutFreeText) {
                dispatch(slice.actions.setAutosuggestData({ ...response.data }));
            } else {
                dispatch(slice.actions.setAutosuggestData({ ...response.data, freeText: searchedVal }));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getMemberDropdownData() {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}users/travclan-admin`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            devConsolelog('response getMemberList', response.data);
            dispatch(slice.actions.setMemberDropdownData([...response.data]));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {} } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export const filtersData =
    (filter = '') =>
    async () => {
        dispatch(slice.actions.setFilters(filter));
    };
